{
  "id": "campaign-087",
  "name": "Foggy Gate",
  "seed": "campaign:87",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    "...,.__.....",
    ".i,i.__.i.i.",
    "...,T__T....",
    ".~...__...x.",
    "~~...__.....",
    ".~.#.__.T..T",
    "....L__.....",
    ".....__.x...",
    "...%.__L..L.",
    "..%%%__.....",
    ",,,%.__.,...",
    ".,...__,,...",
    ".....__.,.x.",
    "............",
    "S..........."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 7,
      "y": 5
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 87,
  "biome": "cemetery",
  "par": {
    "reel": 6941,
    "push": 5927,
    "selfPropelled": 5322,
    "tractor": 4435,
    "zeroTurn": 3617,
    "fairway": 2429
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 21,
      "selfPropelled": 22,
      "tractor": 8,
      "zeroTurn": 6,
      "fairway": 6
    }
  }
}
